/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import React from 'react'
import countries from './codes.json';
export var isNumeric = function isNumeric(char) {
  var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  return numbers.includes(char);
};
export var isCurrency = function isCurrency(char) {
  var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
  return numbers.includes(char);
};
export var maskIt = function maskIt(mask, value) {
  var position = 0;
  var currentChar = 0;
  var masked = '';

  while (position < mask.length && currentChar < value.length) {
    if (mask[position] === '0') {
      masked += value[currentChar];
      currentChar++;
    } else {
      masked += mask[position];
    }

    position++;
  }

  return masked;
};
export var numberCharactersPattern = function numberCharactersPattern(pattern) {
  if (pattern === void 0) {
    pattern = '';
  }

  var numberChars = 0;

  for (var i = 0; i < pattern.length; i++) {
    if (pattern[i] === '0') {
      numberChars++;
    }
  }

  return numberChars;
};
export var searchCountry = function searchCountry(countryCode) {
  var countryFound = countries.find(function (country) {
    if (country.code === countryCode) return country.dialCode;
  });
  return countryFound;
};
export var reverseString = function reverseString(str) {
  return str.split('').reverse().join('');
};
export var formatNumber = function formatNumber(number) {
  // format number 1000000 to 1,000,000
  return number.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var formatPhone = function formatPhone(phone, codeLength) {
  var reversedStr = reverseString(phone);
  var formattedPhone = reversedStr.replace(/\D/g, '');
  var length = formattedPhone.length;
  var isLessThan4 = codeLength < 4;

  if (isLessThan4) {
    if (length > 2) formattedPhone = formattedPhone.replace(/\B(?!(\d{3}))/, '( ');
  } else {
    if (length > 3) formattedPhone = formattedPhone.replace(/\B(?!(\d{4}))/, '( ');
  }

  if (length > 4) formattedPhone = formattedPhone.replace(/\B(?!(\d{3}))/, ' )');
  if (length > 7) formattedPhone = formattedPhone.replace(/\B(?!(\d{4}))/, ' ');
  if (length > 10) formattedPhone = formattedPhone.replace(/\B(?!(\d{4}))/, ' ');
  formattedPhone = reverseString(formattedPhone);

  if (formattedPhone.length > 18) {
    formattedPhone = formattedPhone.substr(0, isLessThan4 ? 18 : 19);
  }

  return formattedPhone.length ? '+' + formattedPhone : '';
};
export var formatDate = function formatDate(date) {
  var reversedStr = reverseString(date);
  var formattedDate = reversedStr.replace(/\D/g, '');
  var length = formattedDate.length;
  if (length > 2) formattedDate = formattedDate.replace(/\B(?!(\d{3}))/, '/');
  if (length > 4) formattedDate = formattedDate.replace(/\B(?!(\d{3}))/, '/');
  formattedDate = reverseString(formattedDate);

  if (formattedDate.length > 10) {
    formattedDate = formattedDate.substr(0, 10);
  }

  return formattedDate.length ? formattedDate : '';
};
export var formatCurrency = function formatCurrency(value, blur) {
  // appends $ to value, validates decimal side
  // and puts cursor back in right position.
  // get input value
  var input_val = value; // don't validate empty input

  if (input_val === '') {
    return;
  } // check for decimal


  if (input_val.indexOf('.') >= 0) {
    // get position of first decimal
    // this prevents multiple decimals from
    // being entered
    var decimal_pos = input_val.indexOf('.'); // split number by decimal point

    var left_side = input_val.substring(0, decimal_pos);
    var right_side = input_val.substring(decimal_pos); // add commas to left side of number

    left_side = formatNumber(left_side); // validate right side

    right_side = formatNumber(right_side); // On blur make sure 2 numbers after decimal

    if (blur) {
      right_side += '00';
    } // Limit decimal to only 2 digits


    right_side = right_side.substring(0, 2); // join number by .

    input_val = '$' + left_side + '.' + right_side;
  } else {
    // no decimal entered
    // add commas to number
    // remove all non-digits
    input_val = formatNumber(input_val);
    input_val = '$' + input_val; // final formatting

    if (blur) {
      input_val += '.00';
    }
  } // send updated string to input


  return input_val;
};